import Insights from './Insights';

export default Insights;
